import { render } from "./DealsOnShoes.vue?vue&type=template&id=599023c3"
import script from "./DealsOnShoes.vue?vue&type=script&lang=js"
export * from "./DealsOnShoes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__